import { Cafe, ClientCafe } from '../apiTypes';

const getDiscount = (client?: ClientCafe | null, loyalty?: Cafe['loyalty']) => {
  if (!client) {
    return 0;
  }

  if (client.discountType === 'personal') {
    return client.personalDiscount;
  }

  if (loyalty?.enabled && client.discountType === 'auto') {
    const discounts = loyalty.matrix.filter((m) => m.sum < client.totalSum);
    return discounts.length ? discounts[discounts.length - 1]?.discount || 0 : 0;
  }

  return 0;
};

export default getDiscount;
